module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-2cc01f24.png";